@if (flag) {
	@switch (flag) {
		@case (AbnormalFlag.AboveMeasurableRange) { &#8593;&#8593;&#8593; }
		@case (AbnormalFlag.AboveCriticalRange) { &#8593;&#8593; }
		@case (AbnormalFlag.AboveNormalRange) { &#8593; }
		@case (AbnormalFlag.Normal) { &nbsp; }
		@case (AbnormalFlag.BelowNormalRange) { &#8595; }
		@case (AbnormalFlag.BelowCriticalRange) { &#8595;&#8595; }
		@case (AbnormalFlag.BelowMeasurableRange) { &#8595;&#8595;&#8595; }
		@default { ? }
	}
}
@else { ? }